<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 2.5rem">
      <el-row type="flex" justify="space-between">
        <div class="sub-title">
          预约：
          <el-button icon="el-icon-document-add" @click="showDialog" size="small" type="primary" class="left-pad" v-if="permission.registration_appoint_create">门诊预约
          </el-button>
          <id-reader @ok="receiveIdCard" :is-used-dialog="false" text="读取身份证并预约" />
        </div>
        <div>
          <el-date-picker size="small" style="width: 10rem" v-model="condition.date" type="date" placeholder="就诊日期" value-format="yyyy-MM-dd" @change="page" />
          <el-select v-model="condition.targetId" size="small" placeholder="科室专家" class="condition-input" filterable clearable @change="page">
            <el-option v-for="item in validTargets" :key="item.id" :value="item.id" :label="item.targetType == '科室' ? item.deptName : item.doctorName">
              <span v-if="item.targetType == '科室'">{{ item.deptName }}</span>
              <span v-if="item.targetType == '专家'">
                <small style="color: #bbb">{{ item.deptName }}：</small>{{ item.doctorName }}</span>
            </el-option>
          </el-select>

          <el-input size="small" class="left-pad condition-wide" type="text" v-on:keyup.enter.native="page" clearable placeholder="卡号或患者姓名" v-model="condition.keyword">
            <el-button slot="append" icon="el-icon-search" @click="page" :disabled="meta.loading">查询 </el-button>
          </el-input>
        </div>
      </el-row>
    </el-header>

    <el-main style="padding: 0px">
      <el-table @filter-change="filterChanged" :data="entities.items" stripe height="91%" v-loading="meta.loading" @sort-change="handleSortChange" class="main-table">
        <!-- <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-popconfirm title="确定要取消预约吗?" icon-color="red" @confirm="cancel(scope.row)" style="margin-left: 5px; margin-right: 5px" v-if="permission.registration_appoint_delete">
              <el-button slot="reference" title="取消预约" type="danger" plain size="mini" circle icon="el-icon-delete"></el-button>
            </el-popconfirm>

            <el-button type="warning" icon="el-icon-money" circle size="small" title="支付取号" :disabled="scope.row.disabledPay" @click="openPay(scope.row)" plain></el-button>
          </template>
        </el-table-column> -->

        <el-table-column sortable="custom" label="就诊号" prop="opNo" min-width="150" align="center">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="view(row)">{{ row.opNo }}</el-link>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" min-width="120" :filters="validRegTypes" :filter-multiple="false" column-key="regType" label="号别" prop="regType">
          <template slot-scope="{ row }">
            {{ row.regType | dictText("RegType") }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="科室医师" prop="deptCode" align="left" width="150">
          <template slot-scope="{ row }">
            {{ row.deptCode | dictText("Dept") }}
            {{ row.doctorName }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="就诊日期" prop="date" align="center" width="100">
          <template slot-scope="{ row }">
            {{ row.date | fmtDate }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" :filters="dictEnum.PeriodType" :filter-multiple="false" column-key="periodType" sortable="custom" label="午别" prop="periodType" align="left">
          <template slot-scope="{ row }">
            {{ row.periodType }}
            <!--{{ row.seqNo }}-->
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="患者" prop="patientName"></el-table-column>
        <el-table-column label="就诊类型" :filters="dictEnum.OpType" :filter-multiple="false" column-key="opType" prop="opType" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.opType == '医保工伤'" type="danger" size="small" effect="plain">{{ row.opType }}</el-tag>
            <el-tag v-else-if="row.opType == '医保'" type="warning" size="small" effect="plain">{{ row.opType }}</el-tag>
            <el-tag v-else type="success" size="small" effect="plain">{{ row.opType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="性别" :filters="dict.Gender" :filter-multiple="false" column-key="patientGender" prop="patientGender" width="100">
          <template slot-scope="scope">
            {{ scope.row.patientGender | dictText("Gender") }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="年龄" prop="patientAge"></el-table-column>
        <el-table-column sortable="custom" label="预约日期" prop="appointmentDate" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.appointmentDate | fmtDate }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" min-width="150" :filters="dict.ValidAppointmentChannel" :filter-multiple="false" column-key="appointmentChannelCode" label="预约渠道" prop="appointmentChannelCode" align="center">
          <template slot-scope="scope">
            {{ scope.row.appointmentChannelCode | dictText("AppointmentChannel") }}
          </template>
        </el-table-column>
      </el-table>

      <pagination :entities="entities" @queryEntities="page" :condition="condition" />
    </el-main>
    <!-- 支付 -->
    <!-- <pay-dialog v-if="showPay" :reg="reg" :visible.sync="showPay" @paid="paid" @cancle="cancelPay"></pay-dialog> -->
    <detail :visible.sync="meta.showDetail" :reg="entity" @refunded="page"></detail>
    <editor v-if="meta.showEditor" @queryEntities="page" :visible.sync="meta.showEditor" :id-card="idCard" />
  </el-container>
</template>

<script>
import api from "./api";
import { mapGetters } from "vuex";

export default {
  components: {
    editor: () => import("./appoint"),
    pagination: () => import("@/components/_com/pagination"),
    detail: () => import("../registry/detail"),
    // "pay-dialog": () => import("@/components/charge/pay")
  },
  data () {
    return {
      condition: {
        sort: "date,periodStart",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 20,
        state: "预约",
        regTypeCode: "",
        deptCode: "",
        doctorName: "",
        periodType: "",
        appointmentChannelCode: "",
        keyword: ""
      },
      entities: {
        items: []
      },
      entity: {},
      meta: {
        showEditor: false,
        showDetail: false,
        loading: false
      },
      idCard: null, // 身份证信息
      showPay: false, // 显示支付组件
      reg: {},
    };
  },
  computed: {
    ...mapGetters(["dict", "user", "dictEnum", "permission"]),
    validAppointmentChannel () {
      if (!this.dict.AppointmentChannel) {
        return [];
      }
      return this.dict.AppointmentChannel.filter(item => !item.disabled);
    },
    validRegTypes () {
      if (!this.dict.RegType) {
        return [];
      }
      return this.dict.RegType.filter((item) => !item.disabled).sort((a, b) => {
        return a.seqNo - b.seqNo;
      });
    },
    validTargets () {
      if (!this.dict.OpTarget) {
        return [];
      }
      return this.dict.OpTarget.filter((item) => item).sort((a, b) => {
        return a.deptCode != b.deptCode ? a.deptCode.localeCompare(b.deptCode) : (a.doctorId || 0) - (b.doctorId || 0);
      });
    },
  },
  created () {
    this.open();
    this.page();
  },
  methods: {
    handleSortChange ({ prop, order }) {
      this.condition.asc = order === "ascending";
      this.condition.sort = prop;
      this.page();
    },
    filterChanged (options) {
      Object.assign(this.condition, options);
      this.page();
    },
    // cancel (row) {
    //   let _this = this;
    //   api.cancelReg(row.id).then(
    //     (res) => {
    //       _this.page();
    //       _this.$message.success("已取消预约");
    //     },
    //     (msg) => {
    //       _this.$message({
    //         type: "error",
    //         message: "无法取消预约,请查看日期是否已过!",
    //       });
    //     }
    //   );
    // },
    async open () {
      this.meta.regTypes = [];
      this.meta.targets = [];
      this.isExpert = false;

      try {
        // 查询门诊科室
        let res = await api.queryTarget({
          sort: "id",
          asc: true,
          pageIndex: 1,
          pageSize: 999,
          targetType: "科室",
        });
        this.meta.targets = res.items.map((item) => (this.isExpert ? { code: item.doctorId.toString(), name: item.doctorName } : { code: item.deptCode, name: item.deptName }));
      } catch (err) {
        if (err) {
          this.$message.error(err.message || err);
        }
      }
    },
    view (row) {
      this.entity = row;
      this.meta.showDetail = true;
    },
    async page () {
      this.meta.loading = true;
      if (this.condition && this.condition.targetId) {
        const conditionParams = this.validTargets.filter((item) => {
          return item.id === this.condition.targetId;
        })[0];
        this.condition = Object.assign(this.condition, {
          deptCode: conditionParams.deptCode,
          deptName: conditionParams.deptName,
          doctorName: conditionParams.doctorName,
        });
        // delete this.condition.targetId;
      } else {
        delete this.condition.deptCode;
        delete this.condition.deptName;
        delete this.condition.doctorName;
      }
      const currentServerTime = await this.$utils.getServerTime(); // 服务器当前时间
      api
        .queryAppointment(this.condition)
        .then((res) => {
          this.entities = res;
          const timestamp = new Date(currentServerTime.replace(/-/g, '/')).getTime();
          // console.log(7070, timestamp, res);
          this.entities.items.forEach((i) => {
            const timeStr = `${i.date} ${i.periodStart}:00`;
            const startTimestamp = new Date(timeStr.replace(/-/g, '/')).getTime();
            i.disabledPay = (startTimestamp < timestamp) || i.paymentState !== '未支付'; // 不可支付标识
            // console.log(1010, timeStr, startTimestamp, i.disabledPay);
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
    showDialog () {
      this.idCard = null;
      this.meta.showEditor = true;
    },
    // 接收身份证读卡信息
    receiveIdCard (data) {
      this.meta.showEditor = true;
      this.idCard = data;
    },
    // openPay (row) {
    //   if (row.paymentState !== '未支付') return;
    //   this.reg = row;
    //   this.showPay = true;
    // },
    // cancelPay () {
    //   this.showPay = false;
    // },
    // paid () {
    //   this.cancelPay();
    //   this.page();
    //   console.log('支付完成，要不要跳转到挂号页面？');
    // },
  }
};
</script>
